import { useSelector } from 'react-redux'

import { selectors } from 'store/selectors'

import { getSectionById } from '@/entities/categories'

import { unEscape } from '@/shared/lib/utils/string/un-escape'
import { TProduct } from '@/shared/types/product-types'

export const useProductPageMeta = (product: TProduct) => {
	const categories = useSelector(selectors.categoriesItems)
	const { title: categoryName } = getSectionById(categories, product.SECTION_ID)
	const SEO_TITLE = `${product.SEO.ELEMENT_META_TITLE || `Купить ${product.TITLE}`}`

	const title = unEscape(SEO_TITLE)
	const description = unEscape(product.SEO.ELEMENT_META_DESCRIPTION)

	return {
		categoryName,
		title,
		description
	}
}
